import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { TaskEditionFormWrapper } from 'src/Components/Forms/Task/TaskEditionFormWrapper';

const EditTaskDrawer = () => {
  const { t } = useTranslation();
  const { assetId } = useParams<{ assetId: string }>();

  return (
    <AnimatedRoutedDrawer
      title={t('tasks.edit.title', 'Modifier la tâche')}
      to={`/asset/${assetId}/tasks`}
    >
      {({ onClose }) => <TaskEditionFormWrapper onClose={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default EditTaskDrawer;
